<template>
  <div id="nipponia-basic" class="nipponia-basic">
    <template v-if="!!$route.meta.single">
      <router-view />
    </template>
    <template v-else>
      <Layout></Layout>
    </template>
    <intro-vue
      :show="showStart"
      @close="toggleShowStart"
      class="hhh"
    ></intro-vue>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Layout from '@/views/layout/layout'
import { createMicroApp } from '@/config/microAppConfig.js'
import actions from '@/shared/qiankun_actions'
import showCurrentApp from '@/utils/showCurrentApp.js'
import watermark from '@/utils/textWatermark.js'
import IntroVue from './views/layout/intro.vue'

export default {
  components: {
    Layout,
    IntroVue,
  },
  provide() {
    return {
      showStart: this.showStart,
      toggleShowStart: this.toggleShowStart,
    }
  },
  data() {
    return {
      showStart: false,
    }
  },
  async created() {
    this.addEnvWatermark()
    this.refresh()
    this.cacheShowStart()

    createMicroApp(this.$route)
    actions.onGlobalStateChange(async (state, prev) => {
      console.log(state, prev, '主应用状态变更监听')
      let { historyAction, loadMicroApp, openTab } = state
      await this.$tabs.activeTabHistoryAction[historyAction]()
      this.$nextTick(() => {
        showCurrentApp()
      })
    })
  },
  computed: {
    ...mapState(['pcCommonData']),
  },
  methods: {
    cacheShowStart() {
      let show = localStorage.getItem('nipponia:show-start')
      if (!show) {
        this.showStart = true
        localStorage.setItem('nipponia:show-start', true)
      }
    },
    toggleShowStart(show) {
      console.log('哈哈哈哈')
      this.showStart = show
    },
    // 添加环境水印
    addEnvWatermark() {
      const env = this.pcCommonData.platApp?.env
      if (env && typeof env === 'object' && env.type === 'test') {
        watermark.set('正在使用', '测试环境')
      }
    },
    refresh() {
      // 页面刷新跳转到首页
      this.$router.replace('/')
    },
  },
}
</script>
<style lang="scss" scoped>
.nipponia-basic {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}
#nipponia-web-start {
  position: fixed;
  top: 40%;
  width: 10px;
  height: 10px;
  background: red;
  left: 40%;
}
</style>
